const _ = require('./enum');
module.exports = {
  [_.CLIENT_SIDE_ENCRYPTION]: { id: _.CLIENT_SIDE_ENCRYPTION, label: 'Client side encryption' },
  [_.CMS_MODULE]: { id: _.CMS_MODULE, label: 'CMS module' },
  [_.DIRECT_API]: { id: _.DIRECT_API, label: 'Direct API' },
  [_.HOSTED_ELEMENTS]: { id: _.HOSTED_ELEMENTS, label: 'Hosted elements' },
  [_.HOSTED_FIELDS]: { id: _.HOSTED_FIELDS, label: 'Hosted fields' },
  [_.HOSTED_PAGE]: { id: _.HOSTED_PAGE, label: 'Hosted page' },
  [_.OTHER]: { id: _.OTHER, label: 'Other' },
};
